import { c as _c } from "react/compiler-runtime";
import InfoCallout from './InfoCallout';

/**
 * Why a withdrawal the Vault can serve still costs a fee (VAU-1383): idle liquidity is spent
 * first, and only the remainder is pulled out of a Market. Rendered only on the plain
 * force-deallocate withdraw — on the in-kind redemption path the remainder does not come back
 * as cash at all, so the sentence would be wrong there.
 */
const ForceDeallocationOrderCallout = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InfoCallout data-testid="force-deallocation-order-callout">This withdrawal uses the Vault's available liquidity first, then withdraws the remaining amount from a market position.</InfoCallout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ForceDeallocationOrderCallout;